import React, { PureComponent } from 'react';
import { noteFromFrequency, frequencyFromNote } from '../../lib/noteHelper';
import PitchVisualizer from './PitchVisualizer';

class NoteHelperTest extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { pitch: 440 };
  }

  render() {
    const note = noteFromFrequency(this.state.pitch);
    return (
      <div>
        <div>NoteHelperTest</div>
        <input type={'number'} value={this.state.pitch} onChange={this.frequencyChanged} />
        <div>{this.state.pitch}</div>
        <div>NoteFromFrequency: {note.toString()}</div>
        <PitchVisualizer note={note} verbose={true} />
        <div>
          Reverse Frequency: {note.pitch + note.accidentalString()} {frequencyFromNote(note)}
        </div>
      </div>
    );
  }

  frequencyChanged = event => {
    console.log('Frequency:', event.target.value);
    this.setState({ pitch: event.target.value });
  };
}

export default NoteHelperTest;
